import { IAgTechGridItem } from '../../Grids/Data/AgTechGridData'
import { AgTechGridEntity } from '../../Grids/Data/AgTechGridEntities'
import { AgTechCreatedIcon, AgTechLoadingIcon, AgTechUpdatedIcon, AgTechWarningIcon } from '../../Icons/AgTechIcons'
import AgTechPopUpOnHoverContainer from '../../Portals/Popups/AgTechPopUpOnHoverContainer'
import AgTechTooltip from '../../Text/AgTechTooltip'
import React from 'react'

export type AgTechGridRowStatusIconProps<TItem extends IAgTechGridItem> = {
    entity: AgTechGridEntity<TItem>
}

export const AgTechGridRowStatusCreatedIcon = <TItem extends IAgTechGridItem>(props: AgTechGridRowStatusIconProps<TItem>) => {
    return (
        <AgTechPopUpOnHoverContainer
            classes="stretched centered container"
            refreshWhenChanged={JSON.stringify(props.entity)}
            popupRenderProps={() => ({
                popup: () => <AgTechTooltip title={props.entity.state.message ?? ''} />,
            })}
            children={() => props.entity.state.wasWritten ? <AgTechCreatedIcon /> : <AgTechLoadingIcon />}
        />
    )
}

export const AgTechGridRowStatusUpdatedIcon = <TItem extends IAgTechGridItem>(props: AgTechGridRowStatusIconProps<TItem>) => {
    return (
        <AgTechPopUpOnHoverContainer
            classes="stretched centered container"
            refreshWhenChanged={JSON.stringify(props.entity)}
            popupRenderProps={() => ({
                popup: () => <AgTechTooltip title={props.entity.state.message ?? 'The selected row has been successfully updated'} />,
            })}
            children={() => <AgTechUpdatedIcon />}
        />
    )
}

export const AgTechGridRowStatusInvalidIcon = <TItem extends IAgTechGridItem>(props: AgTechGridRowStatusIconProps<TItem>) => {
    return (
        <AgTechPopUpOnHoverContainer
            classes="stretched centered container"
            refreshWhenChanged={JSON.stringify(props.entity)}
            popupRenderProps={() => ({
                popup: () => <AgTechTooltip title={props.entity.state.message ?? 'The selected row is in an invalid state'} />,
            })}
            children={() => <AgTechWarningIcon />}
        />
    )
}